import PropTypes from "prop-types"
import React, { useState, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toggleDigitalSignatureDialog } from "../../../../actions/billingDialogs"
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  TextField,
  Link,
  Box,
} from "@material-ui/core"
import logo from "../../../../assets/images/crewmama_logo_plain.svg"

import useStyles from "./styles"
import GreenButton from "../../Common/GreenButton/index"
import { createStripeAccount } from "../../../../actions/users"

const DigitalSignatureDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [fullName, setFullName] = useState("")
  const [termsAccepted, setTermsAccepted] = useState(false)

  const open = useSelector(
    state => state.billingDialogs.digitalSignatureDialogOpen
  )

  const data = useSelector(state => state.billingDialogs.data)
  const acceptFunc = data && data.acceptFunc
  const args = (data && data.args) || []
  const headerLogo = (data && data.headerLogo) || logo

  let clientArr = ["solo-estimate", "solo-invoice", "estimate", "invoice"]
  let isClientView = clientArr.some(item =>
    window.location.pathname.includes(item)
  )
  const handleClose = () => {
    dispatch(toggleDigitalSignatureDialog(false))
    setTimeout(() => {
      setTermsAccepted(false)
      setFullName("")
    }, 150)
  }

  const submitSignature = () => {
    if (acceptFunc) {
      acceptFunc(...args, { fullName, termsAccepted })
    }
    handleClose()
  }

  const correctPolicyLink = useMemo(() => {
    // if current window loc includes what's in the client arr, goes to client privacy policy
    // otherwise, go to crew policy

    let clientDocument = "https://crewmama.com/about/client-msa"
    let crewDocument = "https://crewmama.com/about/vendor-msa"
    return isClientView ? clientDocument : crewDocument
  }, [])

  return (
    <Dialog
      open={open}
      PaperProps={{
        classes: {
          root: classes.dialogPaper,
        },
      }}
    >
      <DialogTitle className={classes.title}>
        <img
          src={headerLogo}
          alt="organization-logo"
          style={{ maxHeight: "100px" }}
        />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Box mt={4} mb={4}>
          <Typography variant="h3">Digital Signature</Typography>
          <Typography variant="subtitle1" style={{ marginTop: "15px" }}>
            Please submit your digital signature:
          </Typography>
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Full Name"
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            style={{ marginTop: "20px" }}
          />
        </Box>
        <Box mt={4} mb={4}>
          <Typography variant="h3">Service Agreement</Typography>
          {!isClientView ? (
            <>
              <Typography variant="subtitle1" style={{ marginTop: "15px" }}>
                Some important points to understand:
              </Typography>
              <Typography
                variant="subtitle1"
                component="li"
                className={classes.listItem}
              >
                Don’t steal our clients
              </Typography>
              <Typography
                variant="subtitle1"
                component="li"
                className={classes.listItem}
              >
                Don't post if you have an NDA
              </Typography>
              <Typography
                variant="subtitle1"
                component="li"
                className={classes.listItem}
              >
                You get paid--when we get paid.
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="subtitle1" style={{ marginTop: "15px" }}>
                Some important reminders:
              </Typography>
              <Typography
                variant="subtitle1"
                component="li"
                className={classes.listItem}
              >
                Crew Mama Canceled Bookings are charged: $100.00 72 hours before
                shoot, 50% of day rate 48 -71 hours before shoot & 100% of day
                rate 24-47 hours before shoot
              </Typography>
              <Typography
                variant="subtitle1"
                component="li"
                className={classes.listItem}
              >
                Payments can be made through Crew Mama via ACH or Credit Card.
              </Typography>
            </>
          )}
        </Box>
        <Box mb={2} display="flex" alignItems="center">
          <Checkbox
            checked={termsAccepted}
            onChange={() => setTermsAccepted(!termsAccepted)}
            color="primary"
          />
          <Typography variant="subtitle1">
            I accept the Crew Mama{" "}
            <Link
              href={correctPolicyLink}
              target="_blank"
              color="secondary"
              underline="always"
            >
              Service Agreement
            </Link>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Box className={classes.buttons}>
          <GreenButton
            variant="contained"
            fullWidth
            onClick={submitSignature}
            disabled={!fullName || !termsAccepted}
          >
            Submit
          </GreenButton>

          <Button
            variant="text"
            fullWidth
            onClick={handleClose}
            style={{ marginTop: "15px" }}
          >
            Cancel
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

DigitalSignatureDialog.propTypes = {
  children: PropTypes.node,
}

export default DigitalSignatureDialog
